import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TOUR_SEQUENCES } from '../tourSequences';
import { useTourSequence } from './useTourSequence';

interface UseTourUrlParamsOptions {
  sequence: ReturnType<typeof useTourSequence>;
  onStartManualTour: (tourId: string) => void;
}

/**
 * Reads tour-related URL parameters on mount and triggers the appropriate tour or sequence.
 *
 * Supports: ?tour=<sequenceId|tourId>&tourMode=manual
 * Cleans up params after reading to prevent re-triggering on refresh.
 */
export function useTourUrlParams({ sequence, onStartManualTour }: UseTourUrlParamsOptions): void {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const tourParam = searchParams.get('tour');
    const tourMode = searchParams.get('tourMode');

    if (!tourParam || tourMode !== 'manual') return;

    // Clean the tour params from URL immediately
    searchParams.delete('tour');
    searchParams.delete('tourMode');
    setSearchParams(searchParams, { replace: true });

    // Check if it's a sequence
    const sequenceDef = TOUR_SEQUENCES[tourParam];
    if (sequenceDef) {
      sequence.startSequence(tourParam);
    } else {
      // Single tour ID
      onStartManualTour(tourParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run only on mount
}
